import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/loading-logo.png'


const _hoisted_1 = {
  id: "loadingPage",
  class: "background-1 position-absolute top-0 bottom-0 start-0 end-0",
  style: {"z-index":"9999"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column min-vh-100 justify-content-center align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"width":"12%"},
    alt: "Logo",
    class: "spinner-img ratio ratio-1x1"
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border text-primary w-h-120-px col-12 my-2",
    role: "status"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}